// extracted by mini-css-extract-plugin
export default {"wrapper":"GuestCategoryNavigation_wrapper__bfVej","heading":"GuestCategoryNavigation_heading__ukIGf","body":"GuestCategoryNavigation_body__0e8zo"};